import React, { Fragment } from 'react';
import config from "../config"

function VersionComponent(props) {

    const allowedVersions = props.desiredVersion.split('v').filter(version => !!parseInt(version)).map(version => `v${version}`);

    const isDisplayable = () => {
        if (!allowedVersions.includes(config.version)) return;

        return (<Fragment>{props.children}</Fragment>);
    }

    return (
        <>
            {isDisplayable()}
        </>
    )
}

export default VersionComponent
